import React, { useState } from "react";
import VRSEARCH from "./teasers/teaser-vrsearch.png";
import COLOR from "./teasers/teaser-color.png";
import CODESIGNREMINSICENCE from "./teasers/teaser-codesignreminsicence.png"
import REMINIBUDDY from "./teasers/teaser-reminibuddy.png"
import ASSESSOR from "./teasers/teaser-abilityassessor.png"
import COLORJOURNAL from "./teasers/teaser-colorjournal.png"
import REMREVIEW from "./teasers/teaser-memoryreview.png"
import posprojector from "./teasers/teaser-posprojector.png"
import mentoringfunctions from "./teasers/teaser-mentoringfunctions.png"
import Typed from "typed.js";


const Research = () => {
  const el = React.useRef(null);
  const [toggle, setToggle] = useState(false);
  const [toggle2, setToggle2] = useState(false);
  const [icon, setIcon] = useState("fa fa-caret-right");

  const [openAbsId, setOpenAbsId] = useState(null);

const toggleAbs = (id) => {
  setOpenAbsId((prev) => (prev === id ? null : id));
};


  React.useEffect(() => {
    const typed = new Typed(el.current, {
      strings: [
        "<i>older adults</i>.",
        "<i>reminiscence</i>.",
        "<i>photos</i>.",
        "<i>technology-mediated elderly care</i>.",
        "<i>conversational agents</i>.",
        "<i>human-ai interaction</i>.",
        "<i>large language model</i>.",
        "<i>human-ai collaboration</i>.",
        "<i>multi-agent system</i>.",
        "<i>virtual reality</i>.",
      ],
      typeSpeed: 60,

      backSpeed: 10,
      backDelay: 1800,
      loop: true,
    });

    return () => {
      // Destroy Typed instance during cleanup to stop animation
      typed.destroy();
    };
  }, []);

  function toggleIcon() {
    if (icon === "fa fa-caret-right") {
      setIcon("fa fa-caret-down");
    } else {
      setIcon("fa fa-caret-right");
    }
  }

    return (
      
        <div className="each-container" id="research-container">
          <div className="research-part">
            <div id="research">
              <div className="title">Research</div>
              <div className="category">
            <span className="typewriter">
              <i>#</i> <span ref={el} className="writertext" />
            </span>
          </div>
          <div className="each-research">
                  <div className="left">
                    <img src={mentoringfunctions} alt="Technology to Support Mentoring" className="image" />
                  </div>
                  <div className="right">
                    <h2>Understanding and Designing Technology to Support Mentoring Functions in Chinese Design Teams</h2>
                    <p className="authors">Luyao Shen, <b>Zhongyue Zhang</b>, Qianjie Wei, Lik-Hang Lee, Pan Hui, Mingming Fan</p>
                    <p className="conference-details">
                    <span className="short-conference-name">IJHCI</span> In International Journal of Human-Computer Interaction
                    </p>
                    <div className="button-container">
                    <a href={`${process.env.PUBLIC_URL}/papers/IJHCI-Mentoring-Functions.pdf`} className="custom-button" target="_blank" rel="noopener noreferrer">PDF</a>
                    <a href="https://doi.org/10.1080/10447318.2026.2651347" className="custom-button" target="_blank">DOI</a>
                    <button
    type="button"
    className="custom-button abs-button"
    onClick={() => toggleAbs("ijhci-1")}
    aria-expanded={openAbsId === "ijhci-1"}
    aria-controls="abs-ijhci-1"
  >
    Abstract {openAbsId === "ijhci-1" ? "▾" : "▸"}
  </button>
    </div>
    {openAbsId === "ijhci-1" && (
  <div className="abstract-box" id="abs-ijhci-1">
    <p className="abstract-text">
    Mentorship effectiveness is highly context-dependent, necessitating empirical investigation to inform the design of intelligent support systems. The design industry's subjectivity and rapid tool iteration intensify reliance on experienced mentors, a demand amplified by the high-pace environment and feature-rich products of Chinese design teams. We conducted in-depth interviews with 23 Chinese designers to investigate this underexplored context. Our findings reveal a fundamental bifurcation of Kram's functions: career functions are instrumentalized for project efficiency, while psychosocial support suffers a systemic deficit driven by a lack of psychological safety. This impairment is rooted in structural challenges like individual traits and educational gaps. Participants proposed an intelligent mentoring system, leveraging technologies both to reduce mentor workload and to mitigate relational risks. Our research contributes a unique account of functional impairment under high-pace contexts and provides actionable design implications for supporting mentoring in the Chinese design industry.
    </p>
  </div>
)}
                  </div>
                </div>
                <br></br>
          <div className="each-research">
                  <div className="left">
                    <img src={REMREVIEW} alt="Reminiscence Technologies Literature Review" className="image" />
                  </div>
                  <div className="right">
                    <h2>From Memory to Meaning: A Systematic Review of Reminiscence Technologies in HCI</h2>
                    <p className="authors"><b>Zhongyue Zhang</b>, Mingqing Xu, Mengyang Wang, Lina Xu, Xu Zhang, Mingming Fan</p>
                    <p className="conference-details">
                    <span className="short-conference-name">CHI 2026</span> In Proceedings of the CHI Conference on Human Factors in Computing Systems
                    </p>
                    <div className="button-container">
                    <a href="https://dl.acm.org/doi/pdf/10.1145/3772318.3791453" className="custom-button" target="_blank">PDF</a>
                    <a href="https://doi.org/10.1145/3772318.3791453" className="custom-button" target="_blank">DOI</a>
                    <button
    type="button"
    className="custom-button abs-button"
    onClick={() => toggleAbs("chi26-1")}
    aria-expanded={openAbsId === "chi26-1"}
    aria-controls="abs-chi26-1"
  >
    Abstract {openAbsId === "chi26-1" ? "▾" : "▸"}
  </button>
    </div>
    {openAbsId === "chi26-1" && (
  <div className="abstract-box" id="abs-chi26-1">
    <p className="abstract-text">
    Technologies designed to support reminiscence, defined as the practice of engaging with one’s personal past, have become a significant area of inquiry within HCI. Although this has generated a diverse range of creative systems, the field still lacks a systematic account of the design principles that guide them. In this paper, we review 60 studies to examine both the psychosocial functions these technologies target and the mechanisms through which they operate. Our analysis suggests a predominant emphasis on positive identity construction and social connection, with comparatively less focus on functions related to everyday problem solving. To synthesize the mechanisms identified, we propose a cue-centered framework that treats mnemonic cues (e.g., photographs) as the basic unit of design. The framework organizes design mechanisms into a four-stage lifecycle: cue generation, augmentation, interaction, and sharing. It provides a conceptual vocabulary for analyzing reminiscence technologies and highlights underexplored opportunities for future research and design.
    </p>
                    
  </div>
)}
                  </div>
                </div>
                <br></br>
                <div className="each-research">
                  <div className="left">
                    <img src={posprojector} alt="PosProjector" className="image" />
                  </div>
                  <div className="right">
                    <h2>PosProjector: An Ambient Projection Notification System for Posture Correction During Desk-Based Study</h2>
                    <p className="authors">Mingqing Xu, <b>Zhongyue Zhang</b>, Zhiyuan Xia, Chao Liu, Mingming Fan</p>
                    <p className="conference-details">
                    <span className="short-conference-name">CHI 2026</span> In Proceedings of the CHI Conference on Human Factors in Computing Systems
                    </p>
                    <div className="button-container">
                    <a href="https://dl.acm.org/doi/pdf/10.1145/3772318.3791156" className="custom-button" target="_blank">PDF</a>
                    <a href="https://doi.org/10.1145/3772318.3791156" className="custom-button" target="_blank">DOI</a>
                    <button
    type="button"
    className="custom-button abs-button"
    onClick={() => toggleAbs("chi26-2")}
    aria-expanded={openAbsId === "chi26-2"}
    aria-controls="abs-chi26-2"
  >
    Abstract {openAbsId === "chi26-2" ? "▾" : "▸"}
  </button>
    </div>
    {openAbsId === "chi26-2" && (
  <div className="abstract-box" id="abs-chi26-2">
    <p className="abstract-text">
    Poor posture during desk-based learning activities can lead to many health issues, such as spinal problems, musculoskeletal discomfort, and myopia. While traditional posture correction systems use immediate feedback to notify users of their wrong posture, they often disrupt users' concentration. This study explores an ambient projection notification system for non-intrusive posture correction notifications during desk-based learning scenarios. Through a notification elicitation study and an expert co-design workshop, we investigated users' perception towards basic elements of projection notification and derived a design space for desk-based projection notification. We then implemented and evaluated PosProjector, an ambient projection notification system, by applying two notification strategies that embody the most representative dimensions of the design space. Results showed that PosProjector can improve users' posture with little task interference and support various media, including paper and tablets. We further discussed the implications of how to design the least intrusive projection notification system for posture correction.
    </p>
  </div>
)}
                  </div>
                </div>
                <br></br>
          <div className="each-research">
                  <div className="left">
                    <img src={CODESIGNREMINSICENCE} alt="Co-design Photo-based Reminiscence with Older Adults" className="image" />
                  </div>
                  <div className="right">
                    <h2>Understanding and Co-designing Photo-based Reminiscence with Older Adults</h2>
                    <p className="authors"><b>Zhongyue Zhang</b>, Lina Xu, Xingkai Wang, Xu Zhang, Mingming Fan</p>
                    <p className="conference-details">
                    <span className="short-conference-name">CSCW 2025</span> In Proceedings of the ACM on Human-Computer Interaction, CSCW
                    </p>
                    <div className="button-container">
                    <a href="https://dl.acm.org/doi/pdf/10.1145/3711094" className="custom-button" target="_blank">PDF</a>
                    <a href="https://dl.acm.org/doi/10.1145/3711094" className="custom-button" target="_blank">DOI</a>
                    <button
    type="button"
    className="custom-button abs-button"
    onClick={() => toggleAbs("cscw25")}
    aria-expanded={openAbsId === "cscw25"}
    aria-controls="abs-cscw25"
  >
    Abstract {openAbsId === "cscw25" ? "▾" : "▸"}
  </button>
    </div>
    {openAbsId === "cscw25" && (
  <div className="abstract-box" id="abs-cscw25">
    <p className="abstract-text">
    Reminiscence, the act of revisiting past memories, is crucial for self-reflection and social interaction, significantly enhancing psychological well-being, life satisfaction, and self-identity among older adults. In HCI and CSCW, there is growing interest in leveraging technology to support reminiscence for older adults. However, understanding how older adults actively use technologies for realistic and practical reminiscence in their daily lives remains limited. This paper addresses this gap by providing an in-depth, empirical understanding of technology-mediated, photo-based reminiscence among older adults. Through a two-part study involving 20 older adults, we conducted semi-structured interviews and co-design sessions to explore their use and vision of digital technologies for photo-based reminiscence activities. Based on these insights, we propose design implications to make future reminiscence technologies more accessible and empowering for older adults.
    </p>
  </div>
)}
                  </div>
                </div>
                <br></br>
              <div className="each-research paper-card">
                  <div className="left">
                    <img src={COLORJOURNAL} alt="Exploring the Effects of Background Colour and Gender on Cognitive Performance of Visual Attention: a Multimodal Approach Using fNIRS and Eye-tracking" className="image" />
                  </div>
                  
                  <div className="right">
                    <h2>Exploring the Effects of Background Colour and Gender on Cognitive Performance of Visual Attention: a Multimodal Approach Using fNIRS and Eye-tracking</h2>
                    <p className="authors">Lina Xu, Bojing Hou, Xingkai Wang, <b>Zhongyue Zhang</b>, Luwen Yu</p>
                    <p className="conference-details">
                    <span className="short-conference-name"> JAIC 2025</span> In Journal of the International Colour Association (2025): 38, 30-40
                    </p>
                    <div className="button-container">
                    <a href={`${process.env.PUBLIC_URL}/papers/JAIC25-Color-Gender-Cognitive-Attention.pdf`} className="custom-button" target="_blank" rel="noopener noreferrer">PDF</a>
      <a href="https://www.aic-publishing.org/ojs/index.php/JAIC/article/view/295" className="custom-button" target="_blank">DOI</a>
      
      <button
    type="button"
    className="custom-button abs-button"
    onClick={() => toggleAbs("jaic25")}
    aria-expanded={openAbsId === "jaic25"}
    aria-controls="abs-jaic25"
  >
    Abstract {openAbsId === "jaic25" ? "▾" : "▸"}
  </button>
    </div>
    {openAbsId === "jaic25" && (
  <div className="abstract-box" id="abs-jaic25">
    <p className="abstract-text">
    The interplay between background colour and individual characteristics such as gender significantly influences cognitive performance in visual attention tasks. While colour's role in cognition has been studied, the impact of low-saturation colours and their gender-specific interactions remains underexplored. This study examined the effects of nine background colours—seven low-saturation hues (red, orange, yellow, green, cyan, blue, purple), standard grey, and standard white—on visual attention among 54 participants (27 males, 27 females) in a dark psychophysical laboratory. A multimodal approach combined cognitive performance data (accuracy and search time), functional near-infrared spectroscopy (fNIRS) data (activation of brain regions associated with visual attention), and eye-tracking measures (fixation and pupil metrics). Results revealed that males exhibited higher accuracy and faster search times on cyan and yellow backgrounds, whereas females demonstrated greater neural activation on orange and cyan backgrounds. Eye-tracking data indicated longer fixation durations for females on orange backgrounds and higher cognitive load for males on blue backgrounds. Correlation analysis revealed contrasting cognitive strategies, females showed a positive correlation between search time and accuracy, while males exhibited a negative correlation. These findings underscore the nuanced role of gender-specific responses to background colour in shaping visual cognition. Insights gained have applications in human-computer interaction, educational tools, and tailored interventions for cognitive impairments.
    </p>
  </div>
)}
                  </div>
                </div>
                <br></br>
              <div className="each-research">
                  <div className="left">
                    <img src={ASSESSOR} alt="Ability Assessment of Older Adults from Practitioners' Perspectives in China" className="image" />
                  </div>
                  
                  <div className="right">
                    <h2>"Watch, Smell, Ask, Touch": Practices, Challenges, and Technological Support in Ability Assessment of Older Adults from Practitioners' Perspectives in China</h2>
                    <p className="authors"><b>Zhongyue Zhang</b>, Yuru Huang, Mengyang Wang, Mingming Fan</p>
                    <p className="conference-details">
                    <span className="short-conference-name">CHI 2025</span> In Proceedings of the CHI Conference on Human Factors in Computing Systems
                    </p>
                    <div className="button-container">
                    <a href="https://dl.acm.org/doi/pdf/10.1145/3706598.3714166" className="custom-button" target="_blank">PDF</a>
      <a href="https://doi.org/10.1145/3706598.3714166" className="custom-button" target="_blank">DOI</a>
      <button
    type="button"
    className="custom-button abs-button"
    onClick={() => toggleAbs("chi25-1")}
    aria-expanded={openAbsId === "chi25-1"}
    aria-controls="abs-chi25-1"
  >
    Abstract {openAbsId === "chi25-1" ? "▾" : "▸"}
  </button>
    </div>
    {openAbsId === "chi25-1" && (
  <div className="abstract-box" id="abs-chi25-1">
    <p className="abstract-text">
    As the global population ages, comprehensively assessing older adults’ physical, cognitive, and social capacities is increasingly crucial for guiding care decisions and resource allocation. While technology shows promise in enhancing these assessments, there is limited understanding of how practitioners conduct such assessments and how they perceive and experience assessment technologies in real-world settings. This paper presents an exploratory study of the practices and experiences of practitioners in China’s Ability Assessment of Older Adults (AAOA), based on 28 on-site observations and in-depth interviews with eight assessors in a large southeastern city. Our findings reveal the adaptive workflows, strategies, and diverse challenges faced by assessors, highlighting the complexity, context-specificity, and collaborative nature of these processes. While grounded in China’s evolving healthcare system, these findings also resonate with broader global challenges in aging care, particularly in resource-constrained settings. Based on these insights, we propose implications for designing practical assessment technologies and considerations for better supporting assessors and older adults across care contexts.
    </p>
  </div>
)}
                  </div>
                </div>
                <br></br>
              <div className="each-research">
                  <div className="left">
                    <img src={REMINIBUDDY} alt="Toward Designing a Multi-agent Conversational Reminiscence System with Digital Artifacts for Older Adults" className="image" />
                  </div>
                  <div className="right">
                    <h2>Chorus of the Past: Toward Designing a Multi-agent Conversational Reminiscence System with Digital Artifacts for Older Adults</h2>
                    <p className="authors">Jingwei Sun, <b>Zhongyue Zhang</b>, Mengyang Wang, Nianlong Li, Yan Xiang, Liuxin Zhang, Yu Zhang, Qianying Wang, Mingming Fan</p>
                    <p className="conference-details">
                    <span className="short-conference-name">CHI 2025</span> In Proceedings of the CHI Conference on Human Factors in Computing Systems
                    </p>
                    <div className="button-container">
                    <a href="https://dl.acm.org/doi/pdf/10.1145/3706598.3713810" className="custom-button" target="_blank">PDF</a>
      <a href="https://doi.org/10.1145/3706598.3713810" className="custom-button" target="_blank">DOI</a>
      <button
    type="button"
    className="custom-button abs-button"
    onClick={() => toggleAbs("chi25-2")}
    aria-expanded={openAbsId === "chi25-2"}
    aria-controls="abs-chi25-2"
  >
    Abstract {openAbsId === "chi25-2" ? "▾" : "▸"}
  </button>
    </div>
    {openAbsId === "chi25-2" && (
  <div className="abstract-box" id="abs-chi25-2">
    <p className="abstract-text">
    Reminiscence has been shown to provide benefits for older adults, but traditionally relies on personal photos as memory cues and interactions with real people who may not always be available. We present ReminiBuddy, a novel LLM-powered multi-agent conversational system, which allows older adults to engage with two distinct agents—one embodying an older identity and the other a younger identity—while using not only personal photos but also 3D models of generic nostalgic objects as memory cues. Our study, with older adult participants, found that the conversational approach both enjoyable and beneficial for reminiscence. While the younger agent was perceived as more emotionally engaging, the older one fostered greater resonance in content. Personal photos prompted autobiographical memories, whereas 3D generic nostalgic objects evoked shared memories of an era, contributing to a more multifaceted reminiscence experience. We further present design implications for better supporting older adults in reminiscing with LLM-powered conversational agents.
    </p>
  </div>
)}
                  </div>
                </div>
                <br></br>
              
                <div className="each-research">
                  <div className="left">
                    <img src={VRSEARCH} alt="VR Search" className="image" />
                  </div>
                  <div className="right">
                    <h2>Toward Facilitating Search in VR With the Assistance of Vision Large Language Models</h2>
                    <p className="authors">Chao Liu, Clarence Chi San Cheung, Mingqing Xu, <b>Zhongyue Zhang</b>, Mingyang Su, Mingming Fan</p>
                    <p className="conference-details">
                    <span className="short-conference-name">VRST 2024</span> In Proceedings of the 30th ACM Symposium on Virtual Reality Software and Technology
                    </p>
                    <div className="button-container">
                  
                    <a href="https://dl.acm.org/doi/pdf/10.1145/3641825.3687742" className="custom-button" target="_blank">PDF</a>
      <a href="https://doi.org/10.1145/3641825.3687742" className="custom-button" target="_blank">DOI</a>
      <button
    type="button"
    className="custom-button abs-button"
    onClick={() => toggleAbs("vrst24")}
    aria-expanded={openAbsId === "vrst24"}
    aria-controls="abs-vrst24"
  >
    Abstract {openAbsId === "vrst24" ? "▾" : "▸"}
  </button>
    </div>
    {openAbsId === "vrst24" && (
  <div className="abstract-box" id="abs-vrst24">
    <p className="abstract-text">
    While search is a common need in Virtual Reality (VR) applications, current approaches are cumbersome, often requiring users to type on a mid-air keyboard using controllers in VR or remove VR equipment to search on a computer. We first conducted a literature review and a formative study, identifying six common search needs: knowing about one object, knowing about the object’s partial details, knowing objects with environmental context, knowing about interactions with objects, and finding objects within field of view (FOV) and out of FOV in the VR scene. Informed by these needs, we designed technology probes that leveraged recent advances in Vision Large Language Models and conducted a probe-based study with users to elicit feedback. Based on the findings, we derived design principles for VR designers and developers to consider when designing a user-friendly search interface in VR. While prior work about VR search tended to address specific aspects of search, our work contributes design considerations aimed at enhancing the ease of search in VR and potential future directions.
    </p>
  </div>
)}
                  </div>
                </div>
                <br></br>
                <div className="each-research">
                  <div className="left">
                    <img src={COLOR} alt="Color" className="image" />
                  </div>
                  <div className="right">
            
                    <h2>The Effect of Reading Background Colour on Human Cognitive Performance Based on Multi-Modal Data Analysis - A Study of Gender Differences</h2>
                    <p className="authors">Lina Xu, Dehan Jia, <b>Zhongyue Zhang</b>, Leyan Huang, Guobin Xia, Luwen Yu</p>
                    <p className="conference-details">
                    <span className="short-conference-name">AIC 2024</span> In Proceedings of the Midterm Meeting of the International Colour Association
                    </p>
                    <div className="button-container">
                    <a href={`${process.env.PUBLIC_URL}/papers/AIC24-Color-Gender.pdf`} className="custom-button" target="_blank" rel="noopener noreferrer">PDF</a>

      <span className="paper-award">🏆 Best Paper Award</span>
      <button
    type="button"
    className="custom-button abs-button"
    onClick={() => toggleAbs("aic24")}
    aria-expanded={openAbsId === "aic24"}
    aria-controls="abs-jaic25"
  >
    Abstract {openAbsId === "aic24" ? "▾" : "▸"}
  </button>
    </div>
    {openAbsId === "aic24" && (
  <div className="abstract-box" id="abs-aic24">
    <p className="abstract-text">
    There has been a significant increase in available information, in the current global context. In
this trend, there is a growing need for people to improve their cognitive abilities in order to
effectively process and manage the vast amounts of information they encounter. Colour, as a
key element of the human cognitive system, has demonstrated a notable impact on information
processing. However, the effects of background colour on human cognitive performance
remain underexplored. Therefore, the primary objective of this study was to investigate whether
different reading background colours affect human performance on cognitive functions and the
specific mechanisms of this effect. To address these objectives, eight low-saturation colours
with a standard white have been selected in the CIE LAB space. Forty participants (20 males
and 20 females) were recruited, and the task response times, accuracy rates, brain activities data
(fNIRS), and eye-tracking data were collected to assess participants’ cognitive performance
across different reading background colours.

The results showed that there were gender differences in human cognitive performance under
different reading background colours. Specifically, the cognitive data indicated that gender had
a considerable impact on the response times of participants (p = 0.003, = 0.206), female
participants had faster response times than males. The physiological data of the FNIRS showed
that there was a significant gender-colour interaction (p = 0.027, = 0.055) in the FPA-L region
associated with higher cognitive functions, male participants exhibited higher activation on
orange backgrounds (p = 0.001). In the DLPFC-R region related to executive power and
attention, the interaction between gender and colour was significant (p = 0.022, = 0.057).
Furthermore, the eye-tracking data suggested that male participants had more difficulty with
task searches on grey, blue, and purple backgrounds (p &lt; 0.035). Cognitive load is higher in
females as evidenced by average pupil diameter.
    </p>
  </div>
)}
                  </div>
                </div>
              </div>
            </div>
          </div>
   
      );
      
};

export default Research;
